import React, { useRef } from 'react';
import { Flex, Text, Box } from 'rebass';
import useOnClickOutside from 'use-onclickoutside';
import { FiTrash2, FiPlusSquare, FiEdit2 } from 'react-icons/fi';
import Grid from 'app/grid/index';

function ImageEditingOptions({
  children,
  bg = 'rgba(0,0,0,.35)',
  sx = {},
  showEditor,
  setShowEditor,
  onEditingClick,
  onImageDeletion,
  destinationImageSrcExists,
  setShowHover,
  ...props
}) {
  const pickerRef = useRef(null);

  useOnClickOutside(pickerRef, () => {
    if (showEditor) {
      setShowEditor(false);
    }
  });

  return (
    <Grid ref={pickerRef}>
      <Box
        sx={{ gridArea: '1 / 1 / 2 / 2', ...sx }}
        onClick={() => {
          // setShowEditor(true);
          onEditingClick()
        }}
        onMouseEnter={() => {
          setShowHover(true);
        }}
        onMouseLeave={() => {
          setShowHover(false);
        }}
      >
        {children}
      </Box>
      {/* {showEditor && (
        <Flex
          alignItems="center"
          justifyContent="center"
          flexDirection="column"
          bg={bg}
          sx={{
            gridArea: '1 / 1 / 2 / 2',
            zIndex: 9999,
            boxShadow: 'inset 0 0 50px rgba(0,0,0,.35)',
            ...sx,
          }}
        >
          <Flex
            sx={{
              boxShadow: '0px 6px 15px -11px rgba(0, 0, 0, 0.35)',
              borderRadius: '200px',
              background: '#FFF',
              py: 5,
              px: 7,
            }}
          >
            <Text
              size={250}
              color="black"
              as={destinationImageSrcExists ? FiEdit2 : FiPlusSquare}
              sx={{ cursor: 'pointer' }}
              onClick={onEditingClick}
            />
            {onImageDeletion && (
              <Text
                size={250}
                color="black"
                as={FiTrash2}
                ml={4}
                sx={{ cursor: 'pointer' }}
                onClick={onImageDeletion}
              />
            )}
          </Flex>
        </Flex>
      )} */}
    </Grid>
  );
}

export default ImageEditingOptions;
